import { FormattedMessage } from 'react-intl';

interface YourDataProductProps {
  product: string;
}

function YourDataProduct({ product }: YourDataProductProps) {
  return <FormattedMessage id={`offerWizard.yourData.product.${product}`} />;
}

export default YourDataProduct;
